var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showFoxCoinsAdd)?_c('div',{staticClass:"foxcoins-add"},[_c('span',[_vm._v(_vm._s(_vm.getLabelText))]),_c('span',{staticClass:"foxcoins-pay"},[_vm._v(" +"+_vm._s(_vm.foxCoinsAddCount))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }